<div class="container-fluid">
  <div class="px-3">
    <div class="row mt-4">
      <div class="col">
        <h1>Log out successful</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>You have been successfully logged out of OnBoard.</p>
      </div>
    </div>
  </div>
</div>
